export default "__VITE_ASSET__mqRbiIgr__"